module.exports = __webpack_public_path__ + "static/img/4.500d6f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sections/4.svg
// module id = MqJ5
// module chunks = 0